<template>
  <div class="c-filter">
    <ElForm class="elementui-common-form-styles clear" v-highlight label-width="60" inline>
      <ElFormItem label-width="0">
        <ElInput v-model.trim="keyword" :placeholder="placeholder" clearable style="width: 220px" @keyup.native.enter="queryAction">
          <i slot="append" @click="queryAction" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>

      <ElFormItem class="g-pull-right">
        <DatePick v-model="datetime" @change="queryAction" style="width: 220px"></DatePick>
      </ElFormItem>

      <ElFormItem label="游戏组">
        <el-select v-model="gameGroupId" @change="queryAction" filterable clearable style="width: 160px">
          <el-option v-for="item in GAME_GROUPS" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="媒体">
        <el-select v-model="media" @change="queryAction" style="width: 160px">
          <el-option value="" label="不限"></el-option>
          <el-option :value="10" label="巨量引擎"></el-option>
          <el-option :value="16" label="腾讯"></el-option>
          <el-option :value="32" label="磁力引擎"></el-option>
          <el-option :value="6" label="超级汇川"></el-option>
          <el-option :value="45" label="百度信息流"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="创建人">
        <ElSelect v-model="opId" clearable filterable placeholder="全部" style="width: 120px" @change="queryAction">
          <el-option v-for="item in PTOM_USERS" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </ElSelect>
      </ElFormItem>
    </ElForm>
  </div>
</template>
<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import DatePick from '@/components/date-range-picker/index.vue'
import { initPageData, GAME_GROUPS, PTOM_USERS } from '@/data/global-opts'

const opId = Cookies.get('ch_op_id')

// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, PTOM_USERS])

export default {
  name: 'targetingFilter',
  components: { DatePick },
  props: {
    placeholder: {
      type: String
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    queryAction() {
      const [beginTime, endTime] = this.datetime || ['', '']
      const params = {
        gameGroupId: this.gameGroupId || undefined,
        mediaId: this.media || undefined,
        createOpId: this.opId || undefined,
        keyword: this.keyword || undefined,
        beginTime,
        endTime
      }
      this.$emit('on-change', params)
    }
  },
  data() {
    const date = moment().subtract(1, 'day').format('YYYY-MM-DD')
    return {
      keyword: '',
      gameGroupId: '', // 游戏组id
      media: '',
      opId: opId ? Number(opId) : '',
      datetime: [date, date]
    }
  },
  created() {
    this.queryAction()
  }
}
</script>
<style lang="scss" scoped></style>
